import { render } from "./DragDropFileLoad.vue?vue&type=template&id=1872328e&ts=true"
import script from "./DragDropFileLoad.vue?vue&type=script&lang=ts"
export * from "./DragDropFileLoad.vue?vue&type=script&lang=ts"

import "./DragDropFileLoad.vue?vue&type=style&index=0&id=1872328e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__